import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/services/api/bitf-api.service';
import { EUsersRole } from '@common/enums/users-role.enum';
import { IBitfApiResponse } from '@interfaces';
import { User } from '@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsersService extends BitfApiService {
  constructor(public injector: Injector) {
    super('users', injector);
  }

  getMe(): Observable<IBitfApiResponse<User>> {
    return super.request<User>({
      path: '/me',
      method: 'GET',
      disableHideLoader: true,
      populate: '*',
    });
  }

  getUsersByRole(role: EUsersRole) {
    return super.get<User>({
      filter: {
        role: {
          name: {
            $eq: role,
          },
        },
      },
      populate: '*',
    });
  }

  getActiveUsers() {
    return super.get<User>({
      filter: {
        blocked: {
          $eq: false,
        },
      },
      populate: 'role',
      size: Number.MAX_SAFE_INTEGER,
    });
  }

  requestInvoiceEmail(
    userId: number,
    data: {
      bookletId: string;
      amount: number;
    }[]
  ): Observable<IBitfApiResponse<void>> {
    return super.post<void>({
      id: userId,
      action: 'request-invoice-email',
      body: { data },
    });
  }
}
